<template>
  <div class="api-detail-container">
    <div class="back">
      <span @click="$router.go(-1)"
        ><i class="iconfont icon-back"></i>返回</span
      >
    </div>
    <div class="content">
      <!-- <div class="head">
        <img
          src="https://ss1.baidu.com/6ONXsjip0QIZ8tyhnq/it/u=3210116116,2698637809&fm=58"
          alt=""
        />
        <div>
          <div>宇通维修一场</div>
          <div>asdasdas</div>
          <div>生产账户</div>
        </div>
      </div> -->
      <table
        border="1"
        bordercolor="#D1CFCF"
        width="100%"
        cellspacing="0"
        cellpadding="10"
        class="month-table"
        style="margin-top: 0"
      >
        <tr>
          <td>车架号</td>
          <td>{{ resData.frame_num }}</td>
          <td>车牌号</td>
          <td>{{ resData.license_num }}</td>
        </tr>
        <tr>
          <td>问题描述</td>
          <td>{{ resData.problem }}</td>
          <td>状态</td>
          <td>{{ resData.status === 1 ? "已解决" : "未解决" }}</td>
        </tr>
        <tr>
          <td>提交时间</td>
          <td>{{ resData.create_time }}</td>
          <td>解决时间</td>
          <td>{{ resData.solve_time }}</td>
        </tr>
        <tr>
          <td>解决方案</td>
          <td>{{ resData.solution }}</td>
          <td>经办人</td>
          <td>{{ resData.person }}</td>
        </tr>
        <tr>
          <td>经办人联系电话</td>
          <td>{{ resData.phone }}</td>
          <!-- <td>状态</td>
          <td>asda</td> -->
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import { getDetail } from '@/api/maintain'
export default {
  data () {
    return {
      id: '',
      resData: []
    }
  },
  created () {
    this.id = this.$route.query.id
    this.getDetailData()
  },
  methods: {
    //获取详情
    getDetailData () {
      getDetail({ id: this.id }).then(da => {
        this.resData = da.data
      })
    },
  }
}
</script>

<style lang="less" scoped>
.api-detail-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  .back {
    color: #42a3df;
    font-size: 20px;
    font-weight: bold;
    padding-bottom: 10px;
    span {
      cursor: pointer;
    }
    .iconfont {
      margin-right: 10px;
    }
  }
  .content {
    flex: 1;
    min-height: 0;
    width: 100%;
    padding: 20px 20px;
    background: #fff;
    box-shadow: 0 0 6px 1px #acacac;
    overflow-y: auto;
    .head {
      display: flex;
      margin-bottom: 20px;
      img {
        border-radius: 50%;
        margin-right: 10px;
      }
    }
  }
}
th,
td {
  padding: 10px;
  // margin: 20px;
  &:nth-child(2n-1) {
    background: #fafafa;
    width: 20%;
    font-weight: 600;
  }
}
</style>
